import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Guest from "@/pages/Guest";
import DeskCard from "@/pages/DeskCard";
import OnePager from "@/pages/OnePager";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/guest" element={<Guest />} />
          <Route path="/desk-card" element={<DeskCard />} />
          <Route path="/one-pager" element={<OnePager />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
